var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKey = function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11C8 12.66 6.65 14 5 14C3.35 14 2 12.65 2 11C2 9.35 3.35 8 5 8C6.65 8 8 9.35 8 11ZM0 11C0 13.76 2.24 16 5 16C7.76 16 10 13.76 10 11C10 9.9 9.63 8.89 9.03 8.07L10.89 6.3L12.3 7.71C12.69 8.1 13.32 8.1 13.71 7.71C13.9 7.51 14 7.26 14 7C14 6.74 13.9 6.49 13.71 6.29L12.34 4.92L12.94 4.35L14.3 5.71C14.69 6.1 15.32 6.1 15.71 5.71C15.9 5.51 16 5.26 16 5C16 4.74 15.9 4.49 15.71 4.29L14.39 2.97L15.7 1.73C15.9 1.53 16 1.26 16 1C16 0.750003 15.91 0.500003 15.73 0.310003C15.35 -0.0899971 14.72 -0.109997 14.32 0.270003L7.54 6.72C6.79 6.27 5.93 6 5 6C2.24 6 0 8.24 0 11Z"
  })));
};
export default SvgKey;